/* TIMER */
export const START_TIMER = "start_timer";
export const STOP_TIMER = "stop_timer";
export const RESET_TIMER = "reset_timer";

/* BOX */
export const CHANGE_BOX_STATE = "changeBoxState";
export const RESET_BOX_STATE = "resetBoxState";

/* SETTINGS */
export const CHANGE_LANGUAGE = "changeLanguage";
export const CHANGE_DISPLAY_MODE = "changeDisplayMode";
